'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { CustomLink } from '@/app/_components/CustomLink';
import type { MenuItem } from './MenuItems';
import { isExternalHref } from './MenuItems';
type MenuIconSize = 'sm' | 'md' | 'lg';
const sizeConfig = {
  sm: {
    bg: 'size-60',
    icon: 'size-36',
    round: 'rounded-large',
    gap: 'gap-4',
    text: 'typo-caption1'
  },
  md: {
    bg: 'size-52',
    icon: 'size-40',
    round: 'rounded-large',
    gap: 'gap-8',
    text: 'typo-body4'
  },
  lg: {
    bg: 'size-80',
    icon: 'size-60',
    round: 'rounded-xxlarge',
    gap: 'gap-8',
    text: 'typo-body4'
  }
} as const;
const getBgHoverClass = (iconBg?: string, size?: MenuIconSize) => {
  if (iconBg === 'bg-Gray-black') return '';
  if (iconBg === 'bg-B-25') return 'group-hover:bg-B-50 group-active:bg-B-100';
  if (size === 'sm') return 'group-hover:bg-Gray-300 group-active:bg-Gray-400';
  return 'group-hover:bg-Gray-100 group-active:bg-Gray-200';
};
export const MenuIconItem = t0 => {
  const $ = _c(38);
  let className;
  let href;
  let item;
  let linkProps;
  let onClick;
  let t1;
  if ($[0] !== t0) {
    ({
      item,
      size: t1,
      href,
      onClick,
      className,
      ...linkProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = href;
    $[3] = item;
    $[4] = linkProps;
    $[5] = onClick;
    $[6] = t1;
  } else {
    className = $[1];
    href = $[2];
    item = $[3];
    linkProps = $[4];
    onClick = $[5];
    t1 = $[6];
  }
  const size = t1 === undefined ? "md" : t1;
  const config = sizeConfig[size];
  const isExternal = isExternalHref(item.href);
  const resolvedHref = href ?? item.href;
  const t2 = isExternal ? "_blank" : undefined;
  const t3 = isExternal ? "noopener noreferrer" : undefined;
  let t4;
  if ($[7] !== className || $[8] !== config.gap) {
    t4 = cn("group flex w-80 flex-col items-center", config.gap, className);
    $[7] = className;
    $[8] = config.gap;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = item.iconBg ?? (size === "sm" ? "bg-Gray-200" : "bg-Gray-50");
  let t6;
  if ($[10] !== config.bg || $[11] !== config.round || $[12] !== item.iconBg || $[13] !== size || $[14] !== t5) {
    t6 = cn("flex items-center justify-center overflow-hidden transition-colors duration-200 ease-out motion-reduce:transition-none", config.bg, config.round, t5, getBgHoverClass(item.iconBg, size));
    $[10] = config.bg;
    $[11] = config.round;
    $[12] = item.iconBg;
    $[13] = size;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const T0 = item.Icon;
  let t7;
  if ($[16] !== config.icon) {
    t7 = cn(config.icon, "transition-transform duration-200 ease-out group-hover:scale-110 group-active:scale-95 motion-reduce:transform-none motion-reduce:transition-none");
    $[16] = config.icon;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== item.Icon || $[19] !== t7) {
    t8 = <T0 originalFill={true} className={t7} />;
    $[18] = item.Icon;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t6 || $[22] !== t8) {
    t9 = <span className={t6}>{t8}</span>;
    $[21] = t6;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const t10 = item.label;
  let t11;
  if ($[24] !== config.text) {
    t11 = cn("line-clamp-2 min-w-full break-keep text-center font-400 text-Gray-900", config.text);
    $[24] = config.text;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== item.label || $[27] !== t11) {
    t12 = <span title={t10} className={t11}>{item.label}</span>;
    $[26] = item.label;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== linkProps || $[30] !== onClick || $[31] !== resolvedHref || $[32] !== t12 || $[33] !== t2 || $[34] !== t3 || $[35] !== t4 || $[36] !== t9) {
    t13 = <CustomLink href={resolvedHref} target={t2} rel={t3} onClick={onClick} className={t4} {...linkProps}>{t9}{t12}</CustomLink>;
    $[29] = linkProps;
    $[30] = onClick;
    $[31] = resolvedHref;
    $[32] = t12;
    $[33] = t2;
    $[34] = t3;
    $[35] = t4;
    $[36] = t9;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  return t13;
};